module.exports = __webpack_public_path__ + "img/6.bc6d7b9c.jpg";